import * as React from 'react';

import Reference from 'shared/newComponents/Reference';
import { SelectorRightComponentProps } from 'shared/newEntities/components/Selector';

import RightIconComponent from '../../../RightIconComponent';

import './OptionRightComponent.modules.scss';

type Props = {
  component: SelectorRightComponentProps;
};

const OptionRightComponent: React.FC<Props> = ({ component }) => {
  const rightIcon = (
    <RightIconComponent styleName="right-component" {...component} />
  );

  if (!component.reference) {
    return rightIcon;
  }

  return (
    <Reference
      disabledOnMobile
      title={component.reference}
      trigger={<div>{rightIcon}</div>}
    />
  );
};

export default React.memo(OptionRightComponent);
